import { useState } from 'react'

/* blocks */
import VideoModal from '@/atoms/Modal/VideoModal'
import CarouselAlt from '../Carousel/CarouselAlt'
import YoutubePlayer from '@/atoms/YoutubePlayer/YoutubePlayer'

/* utils */
import { mmddyyyyDateFormat } from '@/utils/functions/utils'
interface Props {
  title: string
  description: string
  lists: {
    id: string
    title: string
    desc: string
    uploadDate: string
    isNew: boolean
    url: string
  }[]
}

function PepperVideoLibrary({ title, description, lists }: Props) {
  const [showVideoModal, setShowVideoModal] = useState(false)
  const [videoLink, setVideoLink] = useState('')

  const handleVideoButtonClick = (url: string) => {
    setVideoLink(url)
    setShowVideoModal(true)
  }

  return (
    <section className="container | font-body | py-5 md:py-9">
      <h4 className="font-heading | text-3xl lg:text-4xl font-semibold text-black | mb-5">
        {title}
      </h4>
      <p className="text-sm lg:text-xl text-gray-60 | mb-12">{description}</p>
      <CarouselAlt
        sliderClassName="mb-10"
        className="max-w-col-3 md:max-w-col-10 mx-auto"
        autoScroll={false}
        navigationType="all"
        slides={lists.map(list => (
          <button
            key={list.title}
            onClick={() => handleVideoButtonClick(list.url.split('/embed/')[1])}
          >
            <div className="snap-center | border border-gray-40 hover:border-blue-web-50 | transition-colors delay-200 ease-in shadow-md rounded-lg | max-w-[240px] md:max-w-[300px] | relative">
              {list.isNew ? (
                <span className="font-body uppercase text-small text-blue-web-90 | bg-white rounded-md | py-1 px-2 m-3 shadow-md absolute z-10">
                  New
                </span>
              ) : null}
              <YoutubePlayer
                videoId={list.url.split('/embed/')[1]}
                className="rounded-tl-lg rounded-tr-lg relative"
              />
              <div className="flex flex-col | text-left | p-5">
                <h3 className="font-heading | text-xl lg:text-2xl text-black hover:text-blue-web-50 font-semibold | line-clamp-2 | mb-4">
                  {list.title}
                </h3>
                {list.desc ? (
                  <div className="text-sm text-gray-70 | line-clamp-2 | mb-8">
                    {list.desc}
                  </div>
                ) : (
                  <div className="h-9 mb-8" />
                )}
                <div className="flex-grow | text-caption lg:text-sm text-gray-70 | flex items-center">
                  {mmddyyyyDateFormat(list.uploadDate)}
                </div>
              </div>
            </div>
          </button>
        ))}
      />
      {showVideoModal && (
        <VideoModal
          link={`https://www.youtube.com/embed/${videoLink}`}
          handleClose={() => setShowVideoModal(false)}
        />
      )}
    </section>
  )
}

export default PepperVideoLibrary
